module.exports = __webpack_public_path__ + "static/media/building_1.f2d7a524.svg";